import { Controller } from 'stimulus'
import interact from 'interactjs'
import { convertPixelsToPoints } from '../lib/utils'

export default class extends Controller {
  static targets = ['topInput', 'leftInput', 'pageInput']

  connect() {
    this.assignStartingPosition()
    this.bindDraggable()
    this.bindDroppable()
  }

  assignStartingPosition() {
    const left = parseInt(this.leftInputTarget.value) || 0
    const top = parseInt(this.topInputTarget.value) || 0

    this.position = { left: left, top: top }
  }

  bindDraggable() {
    interact(this.element)
      .draggable(
        {
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: '.pdf-viewer__pages',
              endOnly: true
            })
          ],
          listeners: {
            move: (event) => { this.handleMove(event) }
          }
        }
      ).on('dragend', (event) => {
        // Reset top and left to 0 if we go outside the page
        if (this.position['top'] < 0) { this.position['top'] = 0 }
        if (this.position['left'] < 0) { this.position['left'] = 0 }

        this.updateSignaturePosition(event.currentTarget)
      })
  }

  bindDroppable() {
    interact('.pdf-viewer__page__wrapper')
      .dropzone({
        accept: '.pdf-viewer__draggable',
        ondragleave: (event) => { this.handleDroppedClass(event.target, false) },
        ondropdeactivate: (event) => { this.handleDroppedClass(event.target, false) }
      })
  }

  handleDroppedClass(page, isAdded = true) {
    page.classList.toggle('is-dropped', isAdded)
  }

  handleMove(event) {
    this.position['left'] += convertPixelsToPoints(event.dx)
    this.position['top'] += convertPixelsToPoints(event.dy)

    const page = event.dragEnter
    const signature = event.target

    // Add signature to other page
    if (page && !page.contains(signature)) {
      page.appendChild(signature)
      const boundingClientRect = page.getBoundingClientRect()

      this.position['top'] = convertPixelsToPoints(event.clientY - boundingClientRect.top)
      this.handleDroppedClass(page, true)
    }

    this.updateSignaturePosition(signature, page)
  }

  updateSignatureData(left, top, newPage) {
    this.leftInputTarget.value = left
    this.topInputTarget.value = top

    if (newPage && newPage.dataset.pdfViewerPageValue) {
      const pageNumber = parseInt(newPage.dataset.pdfViewerPageValue) || 1
      this.pageInputTarget.value = pageNumber
    }
  }

  updateSignaturePosition(signature, newPage) {
    const left = this.position['left']
    const top = this.position['top']

    signature.style.left = left + 'pt'
    signature.style.top = top + 'pt'

    this.updateSignatureData(left, top, newPage)
  }
}
